export function hasPublicFarmShopAccess(input: {
  enabledFeatures?: string[] | null;
  producerHasFarmShop?: boolean | null;
}): boolean {
  const featureEnabled = input.enabledFeatures?.includes('farm_shop') ?? false;
  const publicOfferingEnabled = input.producerHasFarmShop ?? false;

  return featureEnabled || publicOfferingEnabled;
}
